import { tokens } from "@core/theme/tokens";

// Medidas de la barra lateral (admin.jsx:3799-3825), centralizadas acá en
// vez de escritas a mano en Sidebar.tsx (design-reviewer, corrida
// 2026-08-24-spec-011-portal, pasadas 3-4). `borderRadius: 12` no aparece en
// DESIGN-TOKENS.md (que solo documenta --radius 24px y --radius-sm 15px) —
// es un hueco de esa extracción, no una desviación del código: el
// prototipo usa 12 en estos mismos bloques, así que se preserva tal cual en
// vez de inventar un token nuevo o forzarlo a 15/24.
export const shellStyles = {
  aside: { width: 262, padding: "30px 18px" },
  logo: { gap: 12, padding: "0 8px 26px" },
  title: `600 12.5px ${tokens.font.ui}`,
  titleLetterSpacing: "0.22em",
  subtitle: `500 10.5px ${tokens.font.ui}`,
  subtitleMarginTop: 2,
  navLink: {
    gap: 12,
    padding: "12px 13px",
    borderRadius: 12,
    marginBottom: 4,
    font: `600 13px ${tokens.font.ui}`,
  },
  identity: {
    paddingTop: 20,
    gap: 11,
    padding: "12px 13px",
    borderRadius: 12,
  },
  avatar: { size: 32, fontSize: 11 },
  name: `600 12px ${tokens.font.ui}`,
  profile: `400 10.5px ${tokens.font.ui}`,
  signOut: `600 11px ${tokens.font.ui}`,
} as const;
